import { InstallmentsEnum } from 'app/shared/enums';
import { ApplicationInfo } from './MubiInstallmentsModalViews/ApplicationInfo';
import { Results } from './MubiInstallmentsModalViews/Results';
import { CreditGranted } from './MubiInstallmentsModalViews/CreditGranted';
import { ApplicationDataForm } from './MubiInstallmentsModalViews/ApplicationDataForm';
import { ApplicationSmsForm } from './MubiInstallmentsModalViews/ApplicationSmsForm';
import { Verification } from './MubiInstallmentsModalViews/Verification';

export const mubiInstallmentsModalConfig = [
  {
    greyBackground: false,
    progressBar: null,
    content: ApplicationInfo,
    closeNameEvent: InstallmentsEnum.EventStepNameEntry,
  },
  {
    greyBackground: true,
    progressBar: {
      state: 0,
      title: InstallmentsEnum.FillData,
    },
    content: ApplicationDataForm,
    closeNameEvent: InstallmentsEnum.EventStepNamePersonalData,
  },
  {
    greyBackground: true,
    progressBar: {
      state: 1,
      title: InstallmentsEnum.PutSmsCode,
    },
    content: () =>
      ApplicationSmsForm({
        imgName: 'verification',
        btnContent: InstallmentsEnum.GoToNextStep,
        isConfirmApplication: true,
      }),
    closeNameEvent: InstallmentsEnum.EventStepNameFirstConsentSms,
  },
  {
    greyBackground: true,
    progressBar: {
      state: 1,
      title: InstallmentsEnum.MubiInstallments,
    },
    content: Verification,
    closeNameEvent: InstallmentsEnum.EventStepNameMotionVerification,
  },
  {
    greyBackground: true,
    progressBar: {
      state: 3,
      title: InstallmentsEnum.MubiInstallments,
    },
    content: CreditGranted,
    closeNameEvent: InstallmentsEnum.EventStepNameLoanTerms,
  },
  {
    greyBackground: true,
    progressBar: {
      state: 2,
      title: InstallmentsEnum.SignBySms,
    },
    content: () =>
      ApplicationSmsForm({
        imgName: 'agreement',
        btnContent: InstallmentsEnum.SignAgreement,
        isConfirmApplication: false,
      }),
    closeNameEvent: InstallmentsEnum.EventStepNameSecondConsentSms,
  },
  {
    greyBackground: false,
    progressBar: null,
    content: () => Results({ installmentsAvailable: true }),
    closeNameEvent: InstallmentsEnum.EventStepNameSuccessfulFinish,
  },
  {
    greyBackground: false,
    progressBar: null,
    content: () => Results({ installmentsAvailable: false }),
    closeNameEvent: InstallmentsEnum.EventStepNameRefusal,
  },
];

export const animationConfig = {
  angle: 92,
  spread: 125,
  startVelocity: 55,
  elementCount: 173,
  dragFriction: 0.09,
  duration: 5260,
  stagger: 0,
  width: '23px',
  height: '10px',
  colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
};
